import { atomWithStorage } from "jotai/utils"
import { Employee } from "./api/Application";

interface EmployeeAuth {
    isAuthenticated: boolean;
    employee?:       Employee;
    token?:          string;
}

export const authAtom = atomWithStorage<EmployeeAuth>( "auth", { isAuthenticated: false }, undefined, { getOnInit: true } );